import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Utils } from '../../../core/utils';
import { PatientBehaviorModel, PatientBehaviorType, PatientTargetModel, PromptScheduleModel } from '../../../core/api/models';
import { PatientTargetForChainModel } from '../../models/models';
import { TargetBoxesModule } from '../../../staff/home/target-boxes.module';
import { SharedModule } from '../../shared.module';
import { CollectionGroup, CollectionItem, CollectionNavigationItem } from './session-collection.models';

@Component({
  selector: 'app-session-collection',
  standalone: true,
  imports: [CommonModule, TargetBoxesModule, SharedModule],
  templateUrl: './session-collection.component.html',
  styleUrls: ['../../../staff/home/staff-home.component.css'],
})
export class SessionCollectionComponent {
  @Input() ready = true;
  @Input() started = false;
  @Input() preview = false;
  @Input() showSessionControls = true;
  @Input() busy = false;
  @Input() timerText = '';
  @Input() favoriteTargets: PatientTargetModel[] = [];
  @Input() specialFavoriteTargets: PatientTargetModel[] = [];
  @Input() behaviors: PatientBehaviorModel[] = [];
  @Input() groups: CollectionGroup[] = [];
  @Input() subTargetsDictionary: {[id: number]: PatientTargetForChainModel[]} = {};
  @Input() promptSchedules: PromptScheduleModel[] = [];
  @Input() bottomTargets = true;
  @Input() targetVisible: (target: PatientTargetModel, item: CollectionItem) => boolean = () => true;
  @Input() programInstructions = true;
  @Input() playlistTitle = '';
  @Input() playlistInstructions: string | null | undefined;
  @Input() headingTemplate: TemplateRef<any> | null = null;
  @Input() notesTemplate: TemplateRef<any> | null = null;
  @Input() navigation: CollectionNavigationItem[] = [];
  @Input() allowSearch = false;
  @Input() showSearch = false;
  @Input() searchText = '';
  @Input() showPlaylistDetails = false;
  @Input() showEmptyMessage = false;
  @Output() start = new EventEmitter<void>();
  @Output() end = new EventEmitter<void>();
  @Output() programDetails = new EventEmitter<CollectionItem>();
  @Output() playlistDetails = new EventEmitter<void>();
  @Output() navigationSelected = new EventEmitter<CollectionNavigationItem>();
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() searchToggle = new EventEmitter<void>();
  @Output() clearSearch = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  readonly behaviorType = PatientBehaviorType;
  colorPatternStyle = Utils.colorPatternStyle;
  readableTextColor = Utils.readableTextColor;
}
